import { EpimsBaseEntityDto } from './epim-base.dto';
export class DivestmentStatusDto extends EpimsBaseEntityDto {

   id: string;

    DivestmentStatusName: string;   
    
  SubscriptionUserId: string;
  SubscriberId: string;
  dateCreated: Date;
  dateUpdated?: Date;
  CreatedById: string;
  ModifiedById: string;
  SiteId: string;
  Version: number;

}